module.exports = __webpack_public_path__ + "static/img/sydh.3349558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sydh.png
// module id = 6TnU
// module chunks = 2